// Available regions/locales in the application
export const REGIONS = [
  {
    code: 'fr-be',
    label: 'Benelux - Français',
    countryCode: 'be',
    flagImage: 'images/flags/union.png'
  },
  {
    code: 'nl-be',
    label: 'Benelux - Nederlands',
    countryCode: 'be',
    flagImage: 'images/flags/union.png'
  },
  {
    code: 'dk',
    label: 'Danmark - Dansk',
    countryCode: 'dk',
    flagImage: 'images/flags/dk.png'
  },
  {
    code: 'de',
    label: 'Deutschland - Deutsch',
    countryCode: 'de',
    flagImage: 'images/flags/de.png'
  },
  {
    code: 'en-eg',
    label: 'Egypt – English',
    countryCode: 'eg',
    flagImage: 'images/flags/en-eg.png'
  },
  {
    code: 'fr-fr',
    label: 'France - Français',
    countryCode: 'fr',
    flagImage: 'images/flags/fr-fr.png'
  },
  {
    code: 'is',
    label: 'Island - English',
    countryCode: 'is',
    flagImage: 'images/flags/is.png'
  },
  {
    code: 'it-it',
    label: 'Italia - Italiano',
    countryCode: 'it',
    flagImage: 'images/flags/it-it.png'
  },
  {
    code: 'en-med',
    label: 'Mediterranean - English',
    countryCode: 'med',
    flagImage: 'images/flags/union.png'
  },
  {
    code: 'en-mid',
    label: 'Middle East - English',
    countryCode: 'mid',
    flagImage: 'images/flags/union.png'
  },
  {
    code: 'no',
    label: 'Norge - Norsk',
    countryCode: 'no',
    flagImage: 'images/flags/no.png'
  },
  {
    code: 'pl',
    label: 'Polska - Polski',
    countryCode: 'pl',
    flagImage: 'images/flags/pl.png'
  },
  {
    code: 'fi',
    label: 'Suomi - Suomalainen',
    countryCode: 'fi',
    flagImage: 'images/flags/fi.png'
  },
  {
    code: 'sv',
    label: 'Sverige - Svenska',
    countryCode: 'se',
    flagImage: 'images/flags/sv.png'
  },
  {
    code: 'tr-tr',
    label: 'Türkiye - Türkçe',
    countryCode: 'tr',
    flagImage: 'images/flags/tr-tr.png'
  },
  {
    code: 'en-gb',
    label: 'United Kingdom - English',
    countryCode: 'gb',
    flagImage: 'images/flags/en-gb.png'
  },
  {
    code: 'ua-ua',
    label: 'Україна - Українська',
    countryCode: 'ua',
    flagImage: 'images/flags/ua-ua.png'
  },
  {
    code: 'ru-kz',
    label: 'Центральная Азия - Русский',
    countryCode: 'kz',
    flagImage: 'images/flags/union.png'
  },
];

// Get region by code
export const getRegionByCode = (code) => {
  return REGIONS.find(region => region.code === code);
};

// Get current region from window location
export const getCurrentRegion = () => {
  const pathname = window.location.pathname.replace('/', '');
  return getRegionByCode(pathname) || getRegionByCode('en-gb');
};
